import { Account } from '@/domain/usecases'
import { dependentRequestService } from '@/data/services/dependent/dependent-service'

/**
 * Loads dependent request data
 * Fetches dependent settings and pending requests for user's company
 */
export async function loadDependentRequest(account: Account.Model) {
  const [dependentSettings, dependentRequestStatus] = await Promise.all([
    dependentRequestService.fetchSettings(account.company.uniqueId),
    dependentRequestService.fetchPendingRequests(account.company.uniqueId)
  ])

  const plans = dependentSettings.plans?.filter(plan => plan.enabled) ?? []
  const degreesKinship = dependentSettings.degreesKinship?.filter(degree => degree.allowed) ?? []

  return {
    ...dependentSettings,
    plans,
    degreesKinship,
    pendingResponse: dependentRequestStatus
  }
}
